import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, Form, Tooltip } from "antd";
import { EServiceTemplateDataProcessingInCountriesSpecialTreatment } from "@devowl-wp/api-real-cookie-banner";
import { calculateSafetyMechanismsFromSpecialTreatments } from "@devowl-wp/react-cookie-banner";
import { jsxJoin } from "@devowl-wp/react-utils";
import { useFormTcfVendor } from "../../../../../contexts/formTcfVendor.js";
import { useI18n } from "../../../../../contexts/i18n.js";
import { useServiceDataProcessingCountriesSpecialTreatments } from "../../../../../hooks/useServiceDataProcessingCountriesSpecialTreatments.js";
import { useTerritorialLegalBasisArticles } from "../../../../../hooks/useTerritorialLegalBasisArticles.js";
const FormTcfVendorFieldGeneralDataProcessingInCountriesSpecialTreatments = ()=>{
    const { __, _i } = useI18n();
    const { iso3166OneAlpha2, territorialLegalBasis, predefinedDataProcessingInSafeCountriesLists, vendor: { additionalInformation } } = useFormTcfVendor();
    const specialTreatments = useServiceDataProcessingCountriesSpecialTreatments({
        __,
        _i,
        predefinedDataProcessingInSafeCountriesLists,
        iso3166OneAlpha2,
        territorialLegalBasis
    });
    const { dataProcessingInUnsafeCountriesArticles, dataProcessingInUnsafeCountriesArticlesLinks } = useTerritorialLegalBasisArticles({
        predefinedDataProcessingInSafeCountriesLists,
        iso3166OneAlpha2
    })(territorialLegalBasis);
    return /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        shouldUpdate: (prevValues, nextValues)=>JSON.stringify(prevValues.dataProcessingInCountries) !== JSON.stringify(nextValues.dataProcessingInCountries) || JSON.stringify(prevValues.dataProcessingInCountriesSpecialTreatments) !== JSON.stringify(nextValues.dataProcessingInCountriesSpecialTreatments),
        children: ({ getFieldValue })=>{
            const dataProcessingInCountries = getFieldValue("dataProcessingInCountries");
            const dataProcessingInCountriesSpecialTreatments = getFieldValue("dataProcessingInCountriesSpecialTreatments");
            const { unsafeCountries, allowedSpecialTreatments } = calculateSafetyMechanismsFromSpecialTreatments({
                territorialLegalBasis,
                predefinedDataProcessingInSafeCountriesLists,
                service: {
                    dataProcessingInCountries,
                    dataProcessingInCountriesSpecialTreatments
                }
            });
            const specialTreatmentOptions = specialTreatments.filter(({ value })=>allowedSpecialTreatments.indexOf(value) > -1).map((obj)=>{
                const hasScssTransferMechanism = additionalInformation?.transferMechanisms?.indexOf("SCCs") > -1;
                // TCF supports also Standard Contractual clauses, so we need to force to use the SCCs and the user should not be able to uncheck it
                return obj.value === EServiceTemplateDataProcessingInCountriesSpecialTreatment.StandardContractualClauses ? {
                    ...obj,
                    disabled: hasScssTransferMechanism,
                    label: hasScssTransferMechanism ? /*#__PURE__*/ _jsx(Tooltip, {
                        title: __("The vendor states that standard contractual clauses must be concluded with it in any case. Please make sure that you have a corresponding contract with him!"),
                        overlayStyle: {
                            maxWidth: 500
                        },
                        placement: "bottomLeft",
                        children: obj.label
                    }) : obj.label
                } : obj;
            });
            return /*#__PURE__*/ _jsxs(Form.Item, {
                label: __("Safety mechanisms for data transmission"),
                style: {
                    display: specialTreatmentOptions.length === 0 ? "none" : undefined
                },
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "description",
                        style: {
                            margin: "0px 0px 10px 0px"
                        },
                        children: _i(__("You have selected countries which are considered as unsafe (%s). If you activate one of this safety mechanisms, you do not ask for consent according to {{article/}}, if this kind of consent is activated at all in the settings.", unsafeCountries.map((country)=>iso3166OneAlpha2[country]).join(", ")), {
                            article: jsxJoin(dataProcessingInUnsafeCountriesArticles.map((article, i)=>{
                                return /*#__PURE__*/ _jsx("a", {
                                    href: dataProcessingInUnsafeCountriesArticlesLinks[i],
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: article
                                }, article);
                            }), __(" or "))
                        })
                    }),
                    /*#__PURE__*/ _jsx(Form.Item, {
                        name: "dataProcessingInCountriesSpecialTreatments",
                        noStyle: true,
                        children: /*#__PURE__*/ _jsx(Checkbox.Group, {
                            options: specialTreatmentOptions
                        })
                    })
                ]
            });
        }
    });
};
export { FormTcfVendorFieldGeneralDataProcessingInCountriesSpecialTreatments };
